import { apiClient } from './client'
import type { User, CreateUserInput, UpdateUserInput, UsersListResponse } from '@/types/user'

interface GetUsersParams {
  page?: number
  limit?: number
  search?: string
  active?: boolean
}

export const usersApi = {
  // Get paginated list of users
  getUsers: async (params?: GetUsersParams): Promise<UsersListResponse> => {
    const response = await apiClient.get<UsersListResponse>('/users', { params })
    return response.data
  },

  // Get single user by ID
  getUser: async (id: string): Promise<{ success: boolean; data: User }> => {
    const response = await apiClient.get(`/users/${id}`)
    return response.data
  },

  // Create new user
  createUser: async (data: CreateUserInput): Promise<{ success: boolean; data: User }> => {
    const response = await apiClient.post('/users', data)
    return response.data
  },

  // Update user
  updateUser: async (
    id: string,
    data: UpdateUserInput
  ): Promise<{ success: boolean; data: User }> => {
    const response = await apiClient.patch(`/users/${id}`, data)
    return response.data
  },

  // Delete user (soft delete)
  deleteUser: async (id: string): Promise<{ success: boolean }> => {
    const response = await apiClient.delete(`/users/${id}`)
    return response.data
  },
}
